"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTABLE_EVENT_TYPES = void 0;
const NOTABLE_EVENT_TYPES = exports.NOTABLE_EVENT_TYPES = {
  STATION_START: 'STATION_START',
  STATION_END: 'STATION_END',
  START_MISSION: 'START_MISSION',
  CHECKPOINT: 'CHECKPOINT',
  START_PHASE: 'START_PHASE',
  LITERACY_EVENT: 'LITERACY_EVENT',
  SET_MAP: 'SET_MAP',
  DEATH: 'DEATH',
  END_MISSION: 'END_MISSION',
  CULMINATING_MOMENT: 'CULMINATING_MOMENT',
  COLLABORATIVE_CULMINATING_MOMENT: 'COLLABORATIVE_CULMINATING_MOMENT',
  NAVIGATION_SCREEN: 'NAVIGATION_SCREEN',
  QUESTION_SLOT: 'QUESTION_SLOT'
};